/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: ea99bacb (Fri Jun  5 23:34:18 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
/**
 *
 * @export
 * @interface InviteTeamMemberOptionsAcademicYears
 */
export interface InviteTeamMemberOptionsAcademicYears {
  /**
   *
   * @type number
   * @memberof InviteTeamMemberOptionsAcademicYears
   */
  year: number
  /**
   *
   * @type boolean
   * @memberof InviteTeamMemberOptionsAcademicYears
   */
  isCurrent?: boolean
  /**
   *
   * @type boolean
   * @memberof InviteTeamMemberOptionsAcademicYears
   */
  isDefault?: boolean
}

export function InviteTeamMemberOptionsAcademicYearsFromJSON(
  json: any
): InviteTeamMemberOptionsAcademicYears {
  return InviteTeamMemberOptionsAcademicYearsFromJSONTyped(json, false)
}

export function InviteTeamMemberOptionsAcademicYearsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): InviteTeamMemberOptionsAcademicYears {
  if (json === undefined || json === null) {
    return json
  }
  return {
    year: json['year'],
    isCurrent: !exists(json, 'isCurrent') ? undefined : json['isCurrent'],
    isDefault: !exists(json, 'isDefault') ? undefined : json['isDefault'],
  }
}

export function InviteTeamMemberOptionsAcademicYearsToJSON(
  value?: InviteTeamMemberOptionsAcademicYears | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    year: value.year,
    isCurrent: value.isCurrent,
    isDefault: value.isDefault,
  }
}
